import { action, intercept, makeObservable, observable } from 'mobx'
import { IValidationSchema, pattern, required, validationContext } from 'validx'
import {
  maxLength,
  mustBeValidTaxFormInputValue,
} from 'utils/validation-utils'
import PersonalInfoEditorViewModel from './PersonalInfoEditorViewModel'
import { SpousalProfileVersion } from '../SpousalProfile/SpousalProfileVersion'

export default class SpousalProfileEditorViewModel {
  readonly personalInfoVm = new PersonalInfoEditorViewModel()

  @observable email = ''

  @observable occupation = ''

  private schema: IValidationSchema<this> = {
    email: [
      required('Email is required'),
      pattern('email', 'Must be a valid email'),
    ],
    occupation: [
      mustBeValidTaxFormInputValue(),
      maxLength(100, 'Occupation must not exceed 100 characters'),
    ],
  }

  validation = validationContext(this)

  constructor() {
    makeObservable(this)

    intercept(this, (change) => {
      this.validation.clearErrors(String(change.name))
      return change
    })
  }

  @action.bound
  validate() {
    const ownValid = this.validation.reset().validate(this.schema).isValid
    const personalValid = this.personalInfoVm.validate()
    return ownValid && personalValid
  }

  @action.bound
  reset(profile?: SpousalProfileVersion | null) {
    const personalInfo = profile?.personalInfo
    this.personalInfoVm.reset(
      personalInfo
        ? {
            firstName: personalInfo.firstName,
            middleInitial: personalInfo.middleInitial,
            lastName: personalInfo.lastName,
            dateOfBirth: personalInfo.dateOfBirth,
            personalTaxpayerIdentificationNumber:
              personalInfo.personalTaxpayerIdentificationNumber,
          }
        : undefined,
    )

    this.email = profile?.contactInfo?.email ?? ''
    this.occupation = profile?.occupation ?? ''
    this.validation.reset()
  }
}
